// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Boom_Wrapper__AqFYL","Date":"Boom_Date__2uFbp","Title":"Boom_Title__1JFtW"};